/** Normalize GET /notifications (schema undocumented). */
export const normalizeNotifications = (payload) => {
  const list = Array.isArray(payload)
    ? payload
    : Array.isArray(payload?.notifications)
      ? payload.notifications
      : Array.isArray(payload?.data)
        ? payload.data
        : Array.isArray(payload?.items)
          ? payload.items
          : [];
  return list
    .map((item, index) => {
      if (item == null) return null;
      if (typeof item === 'string') {
        return { id: `n-${index}`, text: item, read: false, createdAt: null };
      }
      if (typeof item !== 'object') return null;
      const text =
        item.message || item.text || item.title || item.body || item.content;
      if (!text) return null;
      return {
        id: String(item._id || item.id || `n-${index}`),
        text: String(text),
        read: item.read === true || item.seen === true,
        createdAt: item.createdAt || item.created_at || item.date || null,
        type: item.type != null ? Number(item.type) : null,
        link: item.link != null ? String(item.link) : null,
      };
    })
    .filter(Boolean);
};
